export default function () {
  return [
    {
      text: this.$t('common.inactive'),
      value: 'inactive',
      inactive: true,
    },
  ];
}
